import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';

import COLORS from '../COLORS';
import passShowImg from '../img/pass-show.svg';
import passHideImg from '../img/pass-hide.svg';

const LabelStyled = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  font-family: NunitoSans;
  font-size: 12px;
  color: ${COLORS.label};
  font-weight: bold;
`;

const InputStyled = styled.input`
  width: 316px;
  height: 34px;
  margin-top: 8px;
  padding-left: 13px;
  padding-right: 13px;
  border-radius: 5px;
  border: solid 1px #f0f4fa;
  background-color: #fafaff;
  box-sizing: border-box;
  font-size: 14px;
`;

const PasswordInputWrapper = styled.div`
  display: flex;
`;

const PassShowImgStyled = styled.img`
  width: 18px;
  height: 18px;
  margin-top: 16px;
  margin-left: -26px;
  opacity: 0.9;
`;

const LabelContentStyled = styled.span`
  ${({ required }) =>
    required &&
    `
    &::after {
        position: absolute;
        content: '*';
        color: red;
        top: 0;
        margin-left: 4px;
    }`}
`;

const PasswordInput = forwardRef(({ label, required }, ref) => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);

  const togglePassword = () => setIsPasswordHidden(!isPasswordHidden);

  return (
    <LabelStyled>
      <LabelContentStyled required={required}>{label}</LabelContentStyled>
      <PasswordInputWrapper>
        <InputStyled
          ref={ref}
          name='password'
          type={isPasswordHidden ? 'password' : 'text'}
          css='padding-right: 30px;'
          minLength='6'
          required={required}
        />
        <PassShowImgStyled
          src={isPasswordHidden ? passShowImg : passHideImg}
          alt='show password'
          onClick={togglePassword}
        />
      </PasswordInputWrapper>
    </LabelStyled>
  );
});

export default PasswordInput;
